<template>
	<div class="main">	
		<router-view v-slot="{ Component }">
		<transition name="fade" mode="out-in">
			<component :is="Component" />
		</transition>
		</router-view>
	</div>
</template>


<script>

export default {
	name: 'Main'
}

</script>


<style lang="scss" scoped>
</style>
